export default function (pathname, userId = 'none') {
  // GAにパスとアカウントIDを渡す
  window.gtagPageview(pathname, userId);
}
